import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { Router} from '@angular/router';

import { Title } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';
import { Observable } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/auth';

import { AngularFirestore } from '@angular/fire/firestore';

import { Kart, Users } from 'my-lib-sanfelici/my-lib-sanfelici';
import { KartsService, AuthService } from 'my-lib-sanfelici';
import { UsersService } from 'my-lib-sanfelici';


@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {
  user: Observable<Users>;
  logo: Observable<any>;
  kart: Observable<Kart>;
  constructor(

    private authservice: AuthService,
    private router: Router,
    private usersservice: UsersService,
    private kartsservice: KartsService,
    public afs: AngularFirestore,
    public afAuth: AngularFireAuth,
    private title: Title,
    @Inject(PLATFORM_ID) private platformId: Object

  ) {
    this.user = this.usersservice.users;
    if (isPlatformBrowser(this.platformId,
    )) {
     this.kart = this.kartsservice.kart;

  }


    this.title.setTitle('Sanfelici');
   }

call(){

}

  ngOnInit() {
this.afAuth.authState.subscribe(u => {
this.authservice.sendAuth(u);
});

  }

}
